












import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class DynamicColumnSelect extends AbpBase {
  @Prop() columns: any[]; //传入的列
  selectedColumns: any = []; //用户勾选的列
  mColumns = [
    {
      type: "selection",
      width: 60,
      align: "center"
    },
    {
      title: "列名",
      key: "title"
    }
  ];

  created() {
    //默认全部选中
    if (this.columns && this.columns.length > 0) {
      this.columns.forEach(item => {
        item._checked = true;
        this.selectedColumns.push(item);
      });
    }
  }

  handleSelect(selection: any, row: any) {
    this.selectedColumns.push(row);
  }

  handleSelectCancel(selection: any, row: any) {
    this.selectedColumns.splice(
      this.selectedColumns.findIndex((x: any) => x.key == row.key),
      1
    );
  }

  handleSelectAll(selection: any) {
    selection.forEach((item: any) => {
      if (this.selectedColumns.findIndex((x: any) => x.key == item.key) == -1) {
        this.selectedColumns.push(item);
      }
    });
  }

  handleSelectAllCancel(selection: any) {
    this.selectedColumns = [];
  }

  onSubmit() {
    return this.selectedColumns;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdMonitor/pdMonitorIndex/dynamicColumnSelect.vue